<template>
  <div class="elixio-connect">
    <span class="resize-loading" v-if="store.loading">
      <span class="loader"></span>
    </span>
    <!-- <h2>{{ $t("COMMON.ELIXIO_CONNECT_MODULES") }}</h2> -->
    <ModulesList
      :modules="store.services"
      :organization="organization"
      @submitted="reloadServices"
      @subscribed="reloadServices"
      @child-activated="reloadServices"
      @child-deactivated="reloadServices"
    />
  </div>
</template>

<script>
import { ModulesList, useElixioConnectStore } from "@latactik/elixio-connect-components-vue2";

export default {
  name: "ModulesListContainer",
  components: { ModulesList },
  props: {
    organization: { type: Object, required: true },
  },
  data() {
    return {
      store: useElixioConnectStore(),
    };
  },
  watch: {
    organization: {
      immediate: true,
      handler(org) {
        if (org?.id) {
          this.store.fetchAllServices(org.id);
        }
      },
    },
  },
  methods: {
    // Re-récupère les services après une (dé)activation/souscription pour que
    // les cards se mettent à jour sans rechargement de la page.
    reloadServices(payload) {
      if (payload && payload.success === false) return;
      if (this.organization?.id) {
        this.store.fetchAllServices(this.organization.id);
      }
    },
  },
};
</script>

<style lang="scss">
.elixio-connect {
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  padding: 20px;
  h2 {
    font-size: 20px;
    line-height: 30px;
    margin: 0;
    color: #000;
    font-family: "Greycliff CF Bold", sans-serif;
  }
}
</style>
